import EntityCell from '@/components/Reports/Cell/NumberCell.vue'

const config = {
  cellRenderer: EntityCell
}
export default {
  type: 'Number',
  config
}
